import * as Yup from "yup";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",

        },
        {
            title:"Entity Name",
            value:"entityName",
            type:"configue"
        },
        {
            title:"Entity Type",
            value:"entityType",
            type:"configue"
        },
        {
            title:"Entity Value",
            value:"entityValue",
            type:"configue"
        },
        {
            title: "Type",
            value: "type",
            type: "configue",
        },
        {
            title: "Licensed Vendor User",
            value: "vendorUser",
            type: "configue"
        },
        {
            title: "Co-Host Link",
            value: "scheduleCopyAction",
            type: "configue"
        }
    ],
    secondaryData: [
        {
            title: "Buffer Start Time",
            value: "bufferedStartTime",
            type: "configue",

        },
        {
            title: "Buffer End Time",
            value: "bufferedEndTime",
            type: "configue",
            
        },
        {
            title: "Actual Start Time",
            value: "actualStartTime",
            type: "configue",
            
        },
        {
            title: "Actual End Time",
            value: "actualEndTime",
            type: "configue",
            
        },
        {
            title: "Created At",
            value: "createdAt",
            type: "configue",
           
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt",
            
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        }
    ],
};

export type SessionAllocation = {
    id: string;
    projectId: string;
    liveSessionId: string;
    nlearn3LiveclassPackageId:string;
    vendorId: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const sessionAllocationInitialValues: SessionAllocation = {
    id: "",
    projectId: "",
    liveSessionId: "",
    nlearn3LiveclassPackageId:"",
    vendorId: "",
    createdAt: "",
    updatedAt: "",
    createdById: "",
    updatedById: "",
    createdByName: "",
    updatedByName: "",
};

export const sessionAllocationMandatoryFields = [];

export const sessionAllocationValidationSchema = Yup.object().shape({
    
});

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}
